module.exports = __webpack_public_path__ + "img/hr-H-B-123456-unload-standup-top.d3b6b07d.png";